import React from 'react';
import './Features.css';

const Features = () => {
  return (
    <section className="features">
      <div className="feature feature1">
        <h2>Fast Conversion</h2>
        <p>AI-powered, lightning-fast code translations for all major languages.</p>
      </div>
      <div className="feature feature2">
        <h2>Wide Language Support</h2>
        <p>Supports over 20 programming languages and frameworks.</p>
      </div>
      <div className="feature feature3">
        <h2>Accurate Translations</h2>
        <p>Translates complex algorithms and ensures syntax accuracy.</p>
      </div>
    </section>
  );
};

export default Features;
